export const designers = `
query Designers($after: String) {
  metaobjects(type: "designer", first: 250, after: $after) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      node {
        handle
        id
        collection: field(key: "collection") {
          reference {
            ... on Collection {
              handle
              title
              id
              onlineStoreUrl
              metafield(namespace: "custom", key: "in_store_only_designer") {
                value
                type
              }
              products(first: 1) {
                nodes {
                  id
                }
              }
            }
          }
        }
        name: field(key: "name") {
          value
        }
      }
    }
  }
}`;
